<div [ngStyle]="{'min-height': clientHeight + 'px', 'margin-bottom': '-55px'}">
    <app-header></app-header>
    <app-toolbar></app-toolbar>
    <app-breadcrumb></app-breadcrumb>
    <ngx-ui-loader></ngx-ui-loader>
    <router-outlet></router-outlet>
    <div style="height: 50px"></div> 
</div>
<app-footer></app-footer>
